export default __webpack_public_path__ + "40681d68e7222e4d602f477e6e3a49b0.svg";